import { createAction, props } from '@ngrx/store';
import { DEFICIENCY_SELECTION, MEASUREMENT_SELECTION } from '../../types/system-condition';

export const updateSystemConditionDeficienciesSelection = createAction(
    '[Forms] Update system condition deficiencies selection',
    props<{
        selected: DEFICIENCY_SELECTION;
        xmlId: string;
    }>(),
);
export const updateSystemConditionRemarks = createAction(
    '[Forms] Update system condition remarks',
    props<{
        newValue: string;
        xmlId: string;
    }>(),
);

export const updateSystemConditionMeasurementsSelection = createAction(
    '[Forms] Update system condition measurement selection',
    props<{
        selected: MEASUREMENT_SELECTION;
        xmlId: string;
    }>(),
);

export const updateSystemConditionDeficiency = createAction(
    '[Forms] Update system condition deficiency,',
    props<{
        xmlId: string | undefined;
    }>(),
);
